/**
 * @author \Edivaldo Mascarenhas
 * @version $Id: carrierMember.model.ts 79367 2018-02-17 00:41:28Z edivaldo.m.junior $
 */
export class CarrierMember {

  public code: string;
  public desc: string;

  public constructor() {

  }

}


// WEBPACK FOOTER //
// ./src/app/models/carrier.model.ts